import { IOffersAdminResponse, TOffer, TPartner } from 'types/offers-temporary';

export const PARTNERLESS_GROUP_NAME = 'Без партнерів';

export const getCompleteOfferPool = (response: IOffersAdminResponse): TOffer[] => {
  const offers = [
    ...(response.plain || []),
    ...Object.values(response.byPartners || {}).flat(),
    ...Object.values(response.byCountries || {}).flat()
  ];

  return offers.filter(
    (offer, index, allOffers) => index === allOffers.findIndex((candidate) => candidate.id === offer.id)
  );
};

export const getPartnerForGroup = (partnerId: string, partners: TPartner[]): TPartner => {
  const partner = partners.find((candidate) => String(candidate.partnerId) === partnerId);
  if (partner) return partner;

  return {
    id: 0,
    partnerId,
    name: PARTNERLESS_GROUP_NAME
  };
};
